import { IRomPatientResult } from '@stores/interfaces';

export const evalScore = record => {
	if (record?.value == -1) return Math.max(0);
	if (record?.normal == 0) return Math.max(100 - record?.value || 0, 0);
	else if (record?.value >= record?.normal) return 100;
	else return parseFloat((record?.value / record?.normal) * 100).toFixed(2);
};

export const jointsTemplateData = [
	{
		key: 'rightShoulder',
		joint: 'Right Shoulder',
		position: { top: 115, left: 70 },
	},
	{
		key: 'leftShoulder',
		joint: 'Left Shoulder',
		position: { top: 115, left: 130 },
	},
	{
		key: 'rightHip',
		joint: 'Right Hip',
		position: { top: 185, left: 85 },
	},
	{
		key: 'leftHip',
		joint: 'Left Hip',
		position: { top: 185, left: 118 },
	},
	{
		key: 'rightKnee',
		joint: 'Right Knee',
		position: { top: 298, left: 82 },
	},
	{
		key: 'leftKnee',
		joint: 'Left Knee',
		position: { top: 298, left: 120 },
	},
	{
		key: 'rightElbow',
		joint: 'Right Elbow',
		position: { top: 150, left: 60 },
	},
	{
		key: 'leftElbow',
		joint: 'Left Elbow',
		position: { top: 150, left: 140 },
	},
	{
		key: 'rightWrist',
		joint: 'Right Wrist',
		position: { top: 198, left: 55 },
	},
	{
		key: 'leftWrist',
		joint: 'Left Wrist',
		position: { top: 198, left: 148 },
	},
	{
		key: 'neck',
		joint: 'Neck',
		position: { top: 92, left: 100 },
	},
	{
		key: 'spine',
		joint: 'Spine',
		position: { top: 160, left: 102 },
	},
];
